export default __webpack_public_path__ + "static/media/Kollektiv35_StimmeX_Web-15.36b176aa.jpg";